"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLeaderboardDisplayFlags = void 0;
const react_1 = require("react");
/**
 * Custom hook that computes display flags for the leaderboard based on event data and current round.
 * These flags determine which UI elements should be shown.
 */
const useLeaderboardDisplayFlags = ({ eventData, leaderboardData = [] }) => {
    const normalizedPlayFormat = (eventData?.playFormat || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    // Individual leaderboard checks
    // Show playoff note when indPlayoffWin is set OR when any row has a finalRank
    // override (adminRank > 0), since finalRank is set specifically to record
    // playoff outcomes when tied players are separated after a playoff round.
    const hasIndividualPlayoffWinner = (0, react_1.useMemo)(() => leaderboardData?.some((score) => score.indPlayoffWin || (score.adminRank != null && score.adminRank > 0)), [leaderboardData]);
    // Teams leaderboard checks
    const hasTeamPlayoffWinner = (0, react_1.useMemo)(() => leaderboardData?.some((score) => score.teamPlayoffWin === true), [leaderboardData]);
    const isTeamEvent = (0, react_1.useMemo)(() => !['single', 'pair'].includes(eventData?.regType?.toLowerCase() || ''), [eventData?.regType]);
    const teamPlayFormat = (0, react_1.useMemo)(() => eventData?.playFormat || '', [eventData?.playFormat]);
    const isWorstBallFormat = (0, react_1.useMemo)(() => normalizedPlayFormat === 'worst ball', [normalizedPlayFormat]);
    const isBestBallFormat = (0, react_1.useMemo)(() => normalizedPlayFormat === 'best ball', [normalizedPlayFormat]);
    const isHighLowFormat = (0, react_1.useMemo)(() => normalizedPlayFormat === 'high low', [normalizedPlayFormat]);
    const isShambleFormat = (0, react_1.useMemo)(() => normalizedPlayFormat === 'shamble', [normalizedPlayFormat]);
    const isBestRoundFormat = (0, react_1.useMemo)(() => normalizedPlayFormat === 'best round', [normalizedPlayFormat]);
    const isSumScoresFormat = (0, react_1.useMemo)(() => !['worst ball', 'best ball', 'high low', 'shamble', 'best round'].includes(normalizedPlayFormat), [normalizedPlayFormat]);
    return {
        hasIndividualPlayoffWinner,
        hasTeamPlayoffWinner,
        isTeamEvent,
        teamPlayFormat,
        isWorstBallFormat,
        isBestBallFormat,
        isHighLowFormat,
        isShambleFormat,
        isBestRoundFormat,
        isSumScoresFormat
    };
};
exports.useLeaderboardDisplayFlags = useLeaderboardDisplayFlags;
